
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1760.508a9.111 9.111 0 003.672-.747 9.726 9.726 0 005.078-5.075 9.43 9.43 0 000-7.334 9.731 9.731 0 00-5.093-5.086 9.406 9.406 0 00-7.324 0 9.731 9.731 0 00-5.083 5.083 9.4 9.4 0 00.007 7.337 9.758 9.758 0 005.08 5.075 9.087 9.087 0 003.663.747zm-.225-4.658a1.113 1.113 0 01-.767-.293.942.942 0 01-.327-.732.953.953 0 01.322-.728 1.149 1.149 0 011.538 0 1.009 1.009 0 010 1.47 1.1 1.1 0 01-.766.283zm.01-2.9q-.85 0-.85-.791v-.117a1.674 1.674 0 01.337-1.089 4.254 4.254 0 01.845-.776 8.417 8.417 0 00.923-.737 1.02 1.02 0 00.308-.767 1.032 1.032 0 00-.361-.82 1.427 1.427 0 00-.967-.312 1.406 1.406 0 00-.776.21 1.848 1.848 0 00-.562.581l-.391.439a.731.731 0 01-.566.186.8.8 0 01-.527-.186.645.645 0 01-.225-.527 1.257 1.257 0 01.1-.488 2.13 2.13 0 011-1.162 3.815 3.815 0 012.031-.488 4.042 4.042 0 011.538.288 2.7 2.7 0 011.138.84 2.15 2.15 0 01.43 1.362 1.931 1.931 0 01-.439 1.333 5.674 5.674 0 01-1.143.952 3.476 3.476 0 00-.728.6 1.034 1.034 0 00-.259.669v.107a.655.655 0 01-.239.5.91.91 0 01-.617.193z"}})])])
          )
        }
      }
    